import * as React from "react";

import { Root } from "./Gray.styles";

interface GrayProps {
    width?: number | string;
    inline?: boolean;
    children: React.ReactNode;
}

export function Gray(props: GrayProps): JSX.Element {
    return (
        <Root inline={props.inline} width={props.width}>
            {props.children}
        </Root>
    );
}
